export default __webpack_public_path__ + "static/media/arrow-right.04e11539.svg";